// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*\n{\n    padding: 0;\n    margin: 0;\n}\n\nbody,\nhtml\n{\n    overflow: hidden;\n    background: black;\n}\n\n.webgl\n{\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: #000000;\n}\n", ""]);
// Exports
module.exports = exports;
